import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import BannerImg from "../../../images/lp/providers-back.jpg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Slide1 from "../../../images/lp/slide-1.png";
import Slide2 from "../../../images/lp/slide-2.png";
import Slide3 from "../../../images/lp/slide-3.png";
import Slide4 from "../../../images/lp/slide-4.png";
import Slide5 from "../../../images/lp/slide-5.png";


const responsive = {
    superLargeDesktop: {
        breakpoint: {max: 4000, min: 1600},
        items: 4
    },
    desktop: {
        breakpoint: {max: 1599, min: 1400},
        items: 3
    },
    tabletlandscape: {
        breakpoint: {max: 1399, min: 1200},
        items: 3
    },
    tablet: {
        breakpoint: {max: 1199, min: 667},
        items: 2
    },
    mobile: {
        breakpoint: {max: 666, min: 0},
        items: 1
    }
};

function Providers(props) {
    return (
        <div className="harness p-100 providers" style={{backgroundImage: `url(${BannerImg})`}}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="example">
                            <h2>Leading Players in the AI as a Service (AIaaS) Landscape</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="provider-content">
                            <p>Discover prominent names designing the AI landscape through groundbreaking AI as a Service offerings.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="cont-extra">
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={3000}
                                  arrows={true} className="carousel_featured" >

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide1}
                                        effect="blur" alt="Amazon Web Services (AWS)" className="img-fluid"
                                    />
                                </div>
                                <div className="provider-slide">
                                    <h6>Amazon Web Services (AWS)</h6>
                                    <p>Utilize Amazon Web Services' AI prowess impeccably using our AI as a Service platform.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide2}
                                        effect="blur" alt="Microsoft Azure" className="img-fluid"
                                    />
                                </div>
                                <div className="provider-slide">
                                    <h6>Microsoft Azure</h6>
                                    <p>Revolutionize business operations with Microsoft Azure's AI tools incorporated into our AIaaS.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide3}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="Google Cloud AI"
                                    />
                                </div>
                                <div className="provider-slide">
                                    <h6>Google Cloud AI</h6>
                                    <p>Unlock the potential of Google Cloud AI smoothly through our AI as a Service offerings.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide4}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="IBM Watson"
                                    />
                                </div>
                                <div className="provider-slide">
                                    <h6>IBM Watson</h6>
                                    <p>Harness IBM Watson's reasoning power through our AI as a Service solutions.</p>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="featured_img">
                                    <LazyLoadImage
                                        src={Slide5}
                                        effect="blur" alt="Tab_01" className="img-fluid" alt="Salesforce Einstein"
                                    />
                                </div>
                                <div className="provider-slide">
                                    <h6>Salesforce Einstein</h6>
                                    <p>Uplift customer engagement with Salesforce Einstein's AI competences via our AIaaS.</p>
                                </div>
                            </div>
                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Providers;